/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

// for backwards compatibility, also export "viewModelInit" on "pli" object
var pli = require("../forms");
pli.viewModelInit = require("./viewModelInit");
module.exports = pli.viewModelInit;




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms-viewmodel/index.js
// module id = 465
// module chunks = 49